import { render, staticRenderFns } from "./BulletinTableItem.vue?vue&type=template&id=2028a012&scoped=true"
import script from "./BulletinTableItem.vue?vue&type=script&lang=js"
export * from "./BulletinTableItem.vue?vue&type=script&lang=js"
import style0 from "./BulletinTableItem.vue?vue&type=style&index=0&id=2028a012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2028a012",
  null
  
)

export default component.exports